<template>
  <div class="files_vue_comp">
    <template>
      <!-- Container for demo; remove or adjust as needed -->

      <v-btn
        style="position: fixed; bottom: 32px; right: 210px; z-index: 500"
        id="fabup"
        fab
        fix
        color="primary"
        class="white--text custom-fab"
        @click="onFabClick"
      >
        <v-icon>$chevup</v-icon>
      </v-btn>
    </template>
    <!-- pdf view -->
    <div
      v-if="pdfview_show"
      style="
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        z-index: 5000;
        background-color: white;
      "
    >
      <div
        v-if="pdfview_show"
        style="color: black; width: 100%; height: auto; text-align: right; margin-right: :10px; padding-right:20px; cursor: pointer; font-weight:600"
        @click="close_pdf"
      >
        X CLOSE
      </div>
      <iframe
        v-if="pdfview_show"
        :src="pdf_final"
        style="width: 100%; height: 100dvh; border: none"
        allowfullscreen
      ></iframe>
    </div>
    <template>
      <v-row justify="center">
        <v-dialog v-model="dialog_upload" persistent max-width="600px">
          <v-card style="background-color: #424242">
            <v-card-title>
              <span class="text-h5">Edit/Update Form</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row dense>
                  <v-col cols="12">
                    <template>
                      <Small>To Update File click in empty field</Small>
                      <v-file-input
                        dark
                        color="white"
                        class="white-icon-file-input"
                        prepend-icon="$pdfIcon"
                        v-model="fileselected"
                        accept="*.pdf"
                        label="Locate File"
                        @change="on_file_selected"
                        hint="Click in empty field"
                      ></v-file-input>
                    </template>
                  </v-col>
                </v-row>
               
                <v-row dense>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      color="gray"
                      readonly
                      v-model="file_item.folder_name"
                      label="Folder Name"
                      required
                      counter="60"
                    ></v-text-field>
                  </v-col>
                     </v-row>
                     <v-row dense>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      color="white"
                      maxlength="500"
                      v-model="file_item.filetitle"
                      label="File Title"
                      required
                      counter="200"
                      hint="People see this name"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row dense>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      color="white"
                      maxlength="500"
                      v-model="file_item.keywords"
                      label="Keywords"
                      required
                      counter="500"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
              <small>*indicates required field</small>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="grey darken-2" @click="savefile">
                Submit Form
              </v-btn>
              <v-btn color="blue darken-1" text @click="close_upload_now">
                Close
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
    <v-main v-if="items_files.length > 0">
      <v-container id="files-container" class="mt-md-0">
        <v-row
          dense
          class="d-flex flex-row justify-space-between justify-md-start"
        >
          <v-col class="top-header flex-grow-0" style="line-height: 2">
            <h3>FORMS</h3>
          </v-col>
          <v-col class="sort-btns d-flex flex-row justify-start pa-0 mt-1">
            <v-btn icon @click="toggleSortByFiletitle('asc')">
              <v-icon class="mr-3">$sortAZ</v-icon>
            </v-btn>
            <v-btn icon @click="toggleSortByFiletitle('desc')">
              <v-icon>$sortZA</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row dense>
          <v-col col="12">
            <v-text-field
              hint="Matches vs Filename, Filetitle, and Keywords."
              color="white"
              v-model="sterm"
              label="Filter Forms"
              clearable
              outlined
              dense
              prepend-inner-icon="$search"
              @input="filter_files"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-container>

      <!-- desk top table -->
      <div v-show="!isMobile" style="display: flow-root">
        <!-- header row -->
        <v-row dense class="">
          <!-- the first column holds the FAV start no text -->
          <div
            class="d-flex align-left mr-4"
            style="width: 24px; min-width: 24px"
          ></div>

          <v-col cols="3" class="form-row-col-header">Form Title</v-col>
          <v-col cols="4" class="form-row-col-header">Keywords</v-col>
          <v-col cols="1" class="form-row-col-header">Uploaded</v-col>
          <v-col cols="3" class="form-row-col-header" style="text-align: center"
            >Actions</v-col
          >
        </v-row>

        <v-row
          align="center"
          v-for="item in items_files"
          :key="item.fileId"
          dense
          class="grey darken-3 mb-4 findeme"
        >
          <!-- Fixed-width flex box for icon -->
          <div
            class="d-flex align-left mr-4"
            style="width: 24px; min-width: 24px"
          >
            <v-icon
              :class="['star pr-2', { 'blue--text text--lighten-2': item.fav }]"
              @click="favme(item)"
            >
              $star
            </v-icon>
          </div>

          <v-col cols="3">
            <span @click="clipboad_url(item)">
              {{ item.filetitle }}
            </span>
          </v-col>
          <v-col cols="4"> {{ item.keywords }}</v-col>
          <v-col cols="1" class="text-caption"> {{ item.s_date }}</v-col>
          <v-col cols="3" class="d-flex justify-center">
            <v-btn
              title="Download"
              class="ml-2"
              style="min-width: 40px; width: 40px"
              @click="pdf_download(item)"
            >
              <v-icon small> $dl </v-icon>
            </v-btn>
            <v-btn
              title="Preview"
              class="ml-2"
              style="min-width: 40px; width: 40px"
              @click="pdfview(item)"
            >
              <v-icon small> $eye </v-icon>
            </v-btn>
            <v-btn
              title="Edit"
              v-if="admin"
              class="ml-2"
              style="min-width: 40px; width: 40px"
              @click="edit(item)"
            >
              <v-icon small> $edit </v-icon>
            </v-btn>
            <v-btn
              title="Delete"
              v-if="admin"
              class="ml-2"
              style="min-width: 40px; width: 40px"
              @click="delete_file_prompt(item)"
            >
              <v-icon small> $del </v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </div>

      <!-- Mobile Cards -->

      <div id="cont-mobile" v-show="isMobile" style="background-color: #757575">
        <v-card
          v-for="item in items_files"
          :key="item.fileId"
          class="mb-3 pa-0 findme-cards"
          color="grey darken-1"
          dark
        >
          <v-card-text class="pa-1" style="font-size: 16px">
            <div style="background-color: #616161" class="pa-1 mb-2">
              <div style>
                <strong>Form Title: </strong>
                <v-icon
                  :class="[
                    'star-m',
                    { 'blue--text text--lighten-2': item.fav },
                  ]"
                  @click="favme(item)"
                >
                  $star
                </v-icon>
              </div>
              <div class="text-right">{{ item.filetitle }}</div>
            </div>
            <div style="background-color: #616161" class="pa-1 mb-2">
              <div style><strong>Keywords:</strong></div>
              <div class="text-right">{{ item.keywords }}</div>
            </div>
            <div style="background-color: #616161" class="pa-1 mb-2">
              <div style><strong>Uploaded:</strong></div>
              <div class="text-right">{{ item.s_date }}</div>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn @click="pdf_download(item)">
              <v-icon large> $dl </v-icon>
            </v-btn>
            <v-btn @click="pdfview(item)">
              <v-icon large> $eye </v-icon>
            </v-btn>
            <v-btn v-if="admin" @click="edit(item)">
              <v-icon large> $edit </v-icon>
            </v-btn>
            <v-btn v-if="admin" @click="delete_file_prompt(item)">
              <v-icon large> $del </v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </v-main>
    <v-main v-if="items_files.length < 1">
      <v-container>
        <h4>No files in this folder</h4>
      </v-container>
    </v-main>
  </div>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

.star-m {
  position: relative;
  top: -3px;
}
.form-row-col-header {
  font-weight: 800;
}

/* 0 media q */
.v-data-table .v-data-table__selected,
.v-data-table .v-data-table__expanded,
.v-data-table tr:hover {
  background-color: transparent !important;
}

@media (min-width: 0px) {
  #files-container {
    margin-top: 0;
  }
  .v-data-table__row:hover {
    background-color: inherit !important;
    cursor: default;
  }
  .bordered-cell {
    border: 1px solid #ccc;
    padding: 8px;
    text-align: left;
  }
  .custom-header {
    color: #1976d2; /* Vuetify primary blue, or choose your own */
    font-weight: bold;
    font-size: 16px;
    text-align: left;
    border: 1px solid #ccc;
  }
  .my-colored-headers >>> thead th {
    color: #d32f2f; /* Example: red text */
    font-weight: bold;
  }

  #files-container {
    width: 95%;
    height: auto;
  }

  .sort-btns {
    width: 20%;
    height: 36px;
  }

  .list-docname .child-1,
  .list-docname .child-2,
  .list-docname .child-3 {
    width: 98%;
  }

  .list-docname h4 {
    width: 15%;
  }

  .name-link {
    color: #90caf9;
    text-decoration: underline;
  }

  .alice h4 {
    color: aliceblue;
  }
}

/* 768 media q */
@media (min-width: 768px) {
  #files-container {
    margin-top: 0;
  }
  .list-docname .child-1 {
    width: 29%;
  }

  .list-docname .child-2 {
    width: 49%;
  }

  .list-docname .child-3 {
    width: 15%;
  }

  .list-docname .child-4 {
    width: 4%;
  }

  .header-1 {
    width: 29%;
  }

  .header-2 {
    width: 47%;
  }

  .header-3 {
    width: 14%;
  }

  .header-4 {
    width: 9%;
  }
}

/* 1025 media q */
@media (min-width: 1025px) {
}

/* 2048 media q */
@media (min-width: 2048px) {
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
import banner from "./banner.vue";
import folder_list from "./folder_list.vue";
import folder from "./folder.vue";

export default {
  name: "files",
  components: {
    banner,
    folder_list,
    folder,
  },
  mixins: [bus_common],
  props: ["files_update", "folder_name", "lst_files"],
  data() {
    return {
      pdfpath: "/pdfjs/web/viewer.html?file=/uploads/",
      pdfzoom: "#zoom=page-fit",
      pdf_final: "",
      pdfview_show: false,
      fileselected: null,
      file_item: {
        fileId: 0,
        filename: "",
        folder_name: "",
        filetitle: "",
        keywords: "",
      },
      dialog_upload: false,
      sterm: "",
      currentSortDirection: "desc",
      isMobile: false,
      headers: [
        {
          text: "Filename",
          align: "start",
          sortable: false,
          value: "filename",
        },
        { text: "Filetitle", value: "filetitle" },
        { text: "Keywords", value: "keywords" },
        { text: "Date", value: "s_date" },
        { text: "Actions", value: "actions", sortable: false },
      ],

      items_files: [],
      right: null,
      search: "",
    };
  },
  watch: {
    "$store.state.user": function () {
      //keep this
      let self = this;
      this.init();
    },
    lst_files: function () {
      this.init();
    },
    files_update: function () {
      console.log("file_update");
      this.get_files();
    },
  },
  computed: {
    admin() {
      return this.$store.state.user.roles.indexOf("forms-admin") > -1;
    },
  },
  methods: {
    onFabClick() {
      console.log("zap");
      const el = document.getElementById("home-container");
      if (el) el.scrollTo({ top: 0, behavior: "smooth" });
    },
    async clipboad_url(item) {
      var text =
        "https://forms.renopdportal.org/pdf/rpd_form?fileId=" + item.fileId;
      try {
        await navigator.clipboard.writeText(text);
        console.log("Text copied to clipboard:", text);
      } catch (err) {
        console.error("Failed to copy text: ", err);
      }
    },
    close_pdf() {
      this.pdfview_show = false;
      this.pdf_final = "";
    },
    pdfview(file) {
      if (!file.filename.toLowerCase().endsWith(".pdf")) {
        console.log("Not a PDF file.");
        this.swall_it(
          "Your Preview",
          "Sorry. Only PDF files are supported in the preview. This file is not a PDF.",
          "warning",
          null,
          null
        );
        return true;
      }

      const el = document.getElementById("vapp");
      if (el) {
        el.scrollTo({
          top: 0,
          behavior: "smooth", // remove for instant jump
        });
      }

      const fn = encodeURIComponent(file.filename);

      console.log("pdf start");
      this.pdf_final = this.pdfpath + fn + this.pdfzoom;
      console.log(this.pdf_final);
      this.pdfview_show = true;
    },
    savefile() {
      this.show_loader(true);
      console.log("update");
      let formData = new FormData();
      formData.append("file", this.fileselected);

      formData.append("email", this.$store.state.user.email);
      formData.append("fileId", this.file_item.fileId);
      formData.append("filename", this.file_item.filename);
      formData.append("filetitle", this.file_item.filetitle);
      formData.append("folder_name", this.file_item.folder_name);
      formData.append("keywords", this.file_item.keywords);
      //     this.$refs.file.value = null;
      this.show_loader(true);
      this.$store
        .dispatch("uploadEditfile", formData)
        .then((data) => {
          let fileName = data;
          this.dialog_upload = false;
          this.fileselected = null;
          this.get_files();
        })
        .catch((msg) => {
          this.show_loader(false);
          this.swall_it("Error Upload File", msg, "error", null, null);
        });
    },
    close_upload_now() {
      this.file_item.folder_name = this.folder_name;
      this.dialog_upload = false;
    },
    on_file_selected() {
      setTimeout(() => {
        this.file_item.filename = this.fileselected.name;
      }, 500);
    },
    edit(file) {
      this.file_item.fileId = file.fileId;
      this.file_item.folder_name = file.folder_name;
      console.log(
        "edit file2: " + file.folder_name,
        this.file_item.folder_name
      );
      this.file_item.filename = file.filename;
      this.file_item.filetitle = file.filetitle;
      this.file_item.keywords = file.keywords;
      this.dialog_upload = true;
    },
    favme(file) {
      this.show_loader(true);
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.fileId = file.fileId;

      formIn.apiname = "favme";

      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          this.show_loader(false);
          if (data.msg.indexOf("favtrue") > -1) {
            this.swall_it(
              "Status",
              "Form added to favorites.",
              "sucess",
              null,
              null
            );
          } else {
            this.swall_it(
              "Status",
              "Form removed from favorites.",
              "sucess",
              null,
              null
            );
          }
          this.$emit("fav_files_update");
          this.get_files();
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error Fave Me", msg, "error", null, null);
        });
    },
    filter_files() {
      var lstel = this.$el.querySelectorAll(".findeme");
      console.log("lstel row: " + lstel.length);

      if (this.sterm == null) {
        //remove filter
        var lst_files_cards = document.querySelectorAll(".findme-cards");
        lst_files_cards.forEach((card) => {
          card.style.display = "block";
        });
        // rows
        var lst_files_rows = this.$el.querySelectorAll(".findeme");
        lst_files_rows.forEach((row) => {
          row.style.display = "flex";
        });
        return true;
      }
      if (this.sterm.length <= 2) {
        //remove filter
        var lst_files_cards = document.querySelectorAll(".findme-cards");
        lst_files_cards.forEach((card) => {
          card.style.display = "block";
        });
        // rows
        var lst_files_rows = this.$el.querySelectorAll(".findeme");
        lst_files_rows.forEach((row) => {
          row.style.display = "flex";
        });
        return true;
      }
      // filter area
      var lst_files_cards = document.querySelectorAll(".findme-cards");
      lst_files_cards.forEach((card) => {
        card.style.display = "none";
      });

      lst_files_cards.forEach((card) => {
        if (
          card.innerHTML.toLowerCase().indexOf(this.sterm.toLowerCase()) > -1
        ) {
          card.style.display = "block";
        }
      });
      // rows
      var lst_files_rows = this.$el.querySelectorAll(".findeme");
      lst_files_rows.forEach((row) => {
        row.style.display = "none";
      });
      lst_files_rows.forEach((row) => {
        if (
          row.innerHTML.toLowerCase().indexOf(this.sterm.toLowerCase()) > -1
        ) {
          row.style.display = "flex";
        }
      });
    },
    toggleSortByFiletitle(sort) {
      console.log("toggleSortByFiletitle: " + sort);
      this.mrbreakpoint("sort");
      var items = this.items_files;
      if (!Array.isArray(items)) return items;

      items.sort((a, b) => {
        const titleA = a.filetitle?.toLowerCase() || "";
        const titleB = b.filetitle?.toLowerCase() || "";

        if (sort === "asc") {
          return titleA.localeCompare(titleB);
        } else {
          return titleB.localeCompare(titleA);
        }
      });

      // Flip direction for next time
      // this.currentSortDirection =
      //   currentSortDirection === "asc" ? "desc" : "asc";

      // return items;
      this.items_files = this.mno(items);
    },
    pdf_download(item) {
      // Trigger download from your component
      const fileId = item.fileId; // replace with real ID
      const email = encodeURIComponent(this.$store.state.user.email);
      const token = encodeURIComponent(this.$store.state.user.token); // optional

      window.open(
        `/pdf/rpd_form?fileId=${fileId}&email=${email}&token=${token}`,
        "_blank"
      );
    },
    // pdf_download(item) {
    //   this.show_loader(true);
    //   var formIn = {};
    //   formIn.email = this.$store.state.user.email;
    //   formIn.token = this.$store.state.user.token;
    //   formIn.fileId = item.fileId;

    //   formIn.apiname = "pdf_download";

    //   var self = this;
    //   this.$store
    //     .dispatch("anyapi", formIn)
    //     .then((data) => {
    //       //  this.swall_it("", msg, "error", null, null);
    //     })
    //     .catch((msg) => {
    //       self.dialog = false;
    //       this.show_loader(false);
    //       this.swall_it("Error pdf_download", msg, "error", null, null);
    //     });
    // },
    checkMobile() {
      this.isMobile = window.innerWidth <= 600;
    },

    download(item) {
      this.mrbreakpoint("go go");
      this.show_loader(true);
      var id = item.fileId;
      console.log("id: " + id);
      var self = this;
      this.$store
        .dispatch("DownLoadFile", id)
        .then((data) => {})
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it(
            "Error im DownloadFilewnload",
            msg,
            "error",
            null,
            null
          );
        });
    },

    delete_file_prompt(item) {
      this.mrbreakpoint("del");
      var self = this;
      console.log(item.filename);
      this.swall_diag(
        "Delete File?",
        "You will permanently Delete '" +
          item.filename +
          "' from the RPD Forms system. Continue?",
        "question",
        function () {
          self.del_file(item);
        },
        null,
        null,
        function () {}
      );
    },

    del_file(file) {
      this.show_loader(true);
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.fileId = file.fileId;

      formIn.apiname = "del_file";

      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          this.show_loader(false);
          this.get_files();
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error del_file", msg, "error", null, null);
        });
    },
    get_files() {
      this.show_loader(true);
      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.folder_name = this.folder_name;

      formIn.apiname = "get_files";

      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          this.show_loader(false);

          self.items_files = data;
          self.items_files.forEach((item) => {
            item.s_date = self.format_date_us(item.s_date);
          });
          this.$emit("fav_files_update");
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error get_all_folders", msg, "error", null, null);
        });
    },

    sendRequest() {
      alert("This button does nothing yet.");
    },
    message1() {
      alert("This will sort the file list");
    },

    message2() {
      alert("when clicked this will open a save to window ");
    },

    message3() {
      alert("when clicked this will open a prompt to delete the file");
    },

    init(self) {
      this.show_loader(false);

      if (this.lst_files == null) {
        this.get_files();
      } else {
        this.mrbreakpoint("wtf");
        this.items_files = this.mno(this.lst_files);
        this.items_files.forEach((item) => {
          item.s_date = this.format_date_us(item.s_date);
        });
      }
    },
  },
  mounted() {
    this.checkMobile();
    window.addEventListener("resize", this.checkMobile);
    var self = this;
    this.$nextTick(() => {
      this.init(self);
    });
  },
};
</script>
